import {Observable} from 'rxjs';

import {PhoneVerificationReq} from '../../components/phone-verification-dialog/PhoneVerificationReq.model';
import {PhoneVerificationReqRes} from '../../components/phone-verification-dialog/PhoneVerificationReqRes.model';

export abstract class BasePhoneVerificationStrategy {

  /**
   * Sends OTP using SMS message
   */
  abstract sendVerificationCode(): Observable<PhoneVerificationReqRes>;

  /**
   * Resends OTP using SMS message
   */
  abstract resendVerificationCode(): Observable<PhoneVerificationReqRes>;

  /**
   * Verifies client's OTP
   * @param request request content
   */
  abstract verifyPhone(request: PhoneVerificationReq): Observable<PhoneVerificationReqRes>;
}
